<div class="expander trial-details">
  <div class="card collapsed">
    <div class="card-header d-flex justify-content-between align-content-end collapsed" id="trialDetailsHeading" aria-expanded="false" aria-controls="trialDetailsCollapse" data-target="#trialDetailsCollapse" (click)="toggleExpander($event)">
      <h5 class="mb-0">Clinical Trial Details </h5>
      <i aria-hidden="true"></i>
    </div>
    <div [attr.id]="'trialDetailsCollapse-' + selectedResearchStudy?.researchStudy?.id" class="collapse" aria-labelledby="trialDetailsHeading">
      <div class="card-body">
        <div class="row">
          <div class="col-9">
            <dl>
              <dt>Clinical Trial Description:</dt>
              <dd>{{ selectedResearchStudy?.description }}</dd>
              <dt>Patient Subjects:</dt>
              <dd>{{ selectedResearchStudy?.group?.name }}</dd>
              <dt>Primary Objective:</dt>
              <dd>{{ selectedResearchStudy?.primaryObjective }}</dd>
              <dt>Clinical Trial Summary:</dt>
              <dd>{{ selectedResearchStudy?.trialSummary }}</dd>
              <dt>Background:</dt>
              <dd>{{ selectedResearchStudy?.background }}</dd>
            </dl>
          </div>
          <div class="col-3">
            <button *ngIf="selectedResearchStudy?.patientMaterialURL" type="button" class="btn btn--white mb-3 w-100" (click)="openLink(selectedResearchStudy?.patientMaterialURL)"> Patient Material</button>
            <button *ngIf="selectedResearchStudy?.sponsorLinkURL" type="button" class="btn btn--white mb-3 w-100" (click)="openLink(selectedResearchStudy?.sponsorLinkURL)"> Sponsor URL Link <i class="fas fa-external-link-alt ml-2" aria-hidden="true"></i></button>
            <button *ngIf="selectedResearchStudy?.protocolLinkURL" type="button" class="btn btn--white mb-3 w-100" (click)="openLink(selectedResearchStudy?.protocolLinkURL)"> Protocol URL Link <i class="fas fa-external-link-alt ml-2" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
